import { render, staticRenderFns } from "./AcknowledgmentManagement.vue?vue&type=template&id=e899103a"
import script from "./AcknowledgmentManagement.vue?vue&type=script&lang=js"
export * from "./AcknowledgmentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports